// The phone's location, read once, at the moment the guard taps a report
// button: never watched, never in the background. The answer is what the
// API takes: a point with its accuracy, or why there is none.
const ERRORS = { 1: 'denied', 2: 'unavailable', 3: 'timeout' };

export const readLocation = (geolocation = typeof navigator !== 'undefined' ? navigator.geolocation : undefined) => new Promise((resolve) => {
  if (!geolocation) {
    resolve({ location_error: 'unavailable' });
    return;
  }
  geolocation.getCurrentPosition(
    (pos) => resolve({
      latitude: Number(pos.coords.latitude.toFixed(6)),
      longitude: Number(pos.coords.longitude.toFixed(6)),
      accuracy_m: Math.round(pos.coords.accuracy * 10) / 10,
    }),
    (err) => resolve({ location_error: ERRORS[err && err.code] || 'unavailable' }),
    { enableHighAccuracy: true, timeout: 15000, maximumAge: 0 },
  );
});
